import { render, staticRenderFns } from "./relatedFullStage.vue?vue&type=template&id=ec0d2bde&scoped=true"
import script from "./relatedFullStage.vue?vue&type=script&lang=ts"
export * from "./relatedFullStage.vue?vue&type=script&lang=ts"
import style0 from "./relatedFullStage.vue?vue&type=style&index=0&id=ec0d2bde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0d2bde",
  null
  
)

export default component.exports